import _objectWithoutProperties from "/codebuild/output/src1506462530/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["accessToken", "refreshToken"];
import { contactApiRequest, getCourseSectionsDataApiRequest, getCustomerCourseApiRequest, getCustomerFilesApiRequest, getCustomerOrderApiRequest, getCustomerOrdersApiRequest, getCustomerProductApiRequest, getProductFilesApiRequest, markFileSeenApiRequest, postCustomerOrdersApiRequest, searchCustomerProductsApiRequest } from '@guryou/api-client';
import { getCustomerEventsApiRequest, getCustomerEventsForWebDealApiRequest, getCustomersApiRequest } from '@guryou/api-client-gql';
import { execute } from './actionWrapper';
import { ActionStatus, buildActionType, executeApiCall } from '../core';
import { SuccessNotification } from '../core/Notification';
import { NotificationType } from '../core/NotificationType';
import { CONTACT, COURSE_SECTIONS, CUSTOMER_BOOKING_EVENTS_FOR_WEB_DEAL_GET_MANY, CUSTOMER_BOOKING_EVENTS_GET_MANY, CUSTOMER_COURSE, CUSTOMER_FILES, CUSTOMER_ORDER, CUSTOMER_ORDERS, CUSTOMER_PRODUCT, CUSTOMER_PRODUCT_BUY, CUSTOMERS_GET_MANY, NOTIFICATION, PRODUCT_FILES, PRODUCT_VIDEOS_GET_MANY } from '../types';
const contactAction = (name, email, subject, message) => async dispatch => {
  dispatch({
    type: buildActionType(CONTACT, ActionStatus.START)
  });
  const response = await contactApiRequest(name, email, subject, message);
  if (response.success) {
    const _response$data = response.data,
      {
        accessToken,
        refreshToken
      } = _response$data,
      user = _objectWithoutProperties(_response$data, _excluded);
    dispatch({
      type: buildActionType(CONTACT, ActionStatus.DONE),
      payload: {
        accessToken,
        refreshToken,
        user
      }
    });
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: "".concat(SuccessNotification[CONTACT.action], " sent us a message"),
        variant: NotificationType.Success
      }
    });
  } else {
    dispatch({
      type: buildActionType(CONTACT, ActionStatus.FAILED)
    });
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: 'There was an error processing your message',
        variant: NotificationType.Error
      }
    });
  }
};
const getCustomerCourse = id => async dispatch => {
  dispatch({
    type: buildActionType(CUSTOMER_COURSE, ActionStatus.START)
  });
  const response = await getCustomerCourseApiRequest(id);
  if (response.success) {
    dispatch({
      type: buildActionType(CUSTOMER_COURSE, ActionStatus.DONE),
      payload: response.data
    });
  } else {
    dispatch({
      type: buildActionType(CUSTOMER_COURSE, ActionStatus.FAILED)
    });
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: 'There was an error getting the course',
        variant: NotificationType.Error
      }
    });
  }
};
const getCustomerOrder = orderId => async dispatch => {
  dispatch({
    type: buildActionType(CUSTOMER_ORDER, ActionStatus.START)
  });
  const response = await getCustomerOrderApiRequest(orderId);
  if (response.success) {
    dispatch({
      type: buildActionType(CUSTOMER_ORDER, ActionStatus.DONE),
      payload: response.data
    });
  } else {
    dispatch({
      type: buildActionType(CUSTOMER_ORDER, ActionStatus.FAILED)
    });
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: 'There was an error getting the order',
        variant: NotificationType.Info
      }
    });
  }
};
const getCustomerOrders = () => async dispatch => {
  dispatch({
    type: buildActionType(CUSTOMER_ORDERS, ActionStatus.START)
  });
  const response = await getCustomerOrdersApiRequest();
  if (response.success) {
    dispatch({
      type: buildActionType(CUSTOMER_ORDERS, ActionStatus.DONE),
      payload: response.data
    });
  } else {
    dispatch({
      type: buildActionType(CUSTOMER_ORDERS, ActionStatus.FAILED)
    });
    if (response.status !== 404) {
      dispatch({
        type: NOTIFICATION,
        payload: {
          message: 'There was an error getting the orders',
          variant: NotificationType.Info
        }
      });
    }
  }
};
const getCustomerProduct = id => async dispatch => {
  dispatch({
    type: buildActionType(CUSTOMER_PRODUCT, ActionStatus.START)
  });
  const response = await getCustomerProductApiRequest(id);
  if (response.success) {
    dispatch({
      type: buildActionType(CUSTOMER_PRODUCT, ActionStatus.DONE),
      payload: response.data
    });
  } else {
    dispatch({
      type: buildActionType(CUSTOMER_PRODUCT, ActionStatus.FAILED)
    });
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: 'There was an error getting the product',
        variant: NotificationType.Info
      }
    });
  }
};
const getCustomerFiles = id => async dispatch => {
  dispatch({
    type: buildActionType(CUSTOMER_FILES, ActionStatus.START)
  });
  const response = await getCustomerFilesApiRequest(id);
  if (response.success) {
    dispatch({
      type: buildActionType(CUSTOMER_FILES, ActionStatus.DONE),
      payload: response.data
    });
  } else {
    dispatch({
      type: buildActionType(CUSTOMER_FILES, ActionStatus.FAILED)
    });
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: 'There was an error getting the files',
        variant: NotificationType.Info
      }
    });
  }
};
const getProductFiles = (authHeaders, slug, id) => async dispatch => {
  dispatch({
    type: buildActionType(PRODUCT_FILES, ActionStatus.START)
  });
  const response = await getProductFilesApiRequest(authHeaders, slug, id);
  if (response.success) {
    dispatch({
      type: buildActionType(PRODUCT_FILES, ActionStatus.DONE),
      payload: response.data
    });
  } else {
    dispatch({
      type: buildActionType(PRODUCT_FILES, ActionStatus.FAILED)
    });
    if (response.status !== 401) {
      dispatch({
        type: NOTIFICATION,
        payload: {
          message: 'There was an error getting the product files',
          variant: NotificationType.Info
        }
      });
    }
  }
};
const markFileSeen = (id, videoId, method) => async dispatch => {
  dispatch({
    type: buildActionType(PRODUCT_FILES, ActionStatus.START)
  });
  const response = await markFileSeenApiRequest(id, videoId, method);
  if (response.success) {
    dispatch({
      type: buildActionType(PRODUCT_FILES, ActionStatus.DONE),
      payload: response.data
    });
  } else {
    dispatch({
      type: buildActionType(PRODUCT_FILES, ActionStatus.FAILED)
    });
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: 'There was an error marking this file as seen',
        variant: NotificationType.Info
      }
    });
  }
};
const getCourseSections = courseId => async dispatch => {
  dispatch({
    type: buildActionType(COURSE_SECTIONS, ActionStatus.START)
  });
  const response = await getCourseSectionsDataApiRequest(courseId);
  if (response.success) {
    dispatch({
      type: buildActionType(COURSE_SECTIONS, ActionStatus.DONE),
      payload: response.data
    });
  } else {
    dispatch({
      type: buildActionType(COURSE_SECTIONS, ActionStatus.FAILED)
    });
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: 'There was an error getting the course sections',
        variant: NotificationType.Info
      }
    });
  }
};
const buyCustomerProduct = (userId, providerId, productId) => async dispatch => {
  dispatch({
    type: buildActionType(CUSTOMER_PRODUCT_BUY, ActionStatus.START)
  });
  const response = await postCustomerOrdersApiRequest(userId, providerId, productId);
  if (response.success) {
    dispatch({
      type: buildActionType(CUSTOMER_PRODUCT_BUY, ActionStatus.DONE),
      payload: {
        data: response.data,
        report: response.report
      }
    });
  } else {
    dispatch({
      type: buildActionType(CUSTOMER_PRODUCT_BUY, ActionStatus.FAILED)
    });
    dispatch({
      type: NOTIFICATION,
      payload: {
        message: 'There was an error purchasing this product',
        variant: NotificationType.Info
      }
    });
  }
};
const getCustomers = function () {
  let notArchived = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  let active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  let isApproved = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return async dispatch => {
    dispatch({
      type: buildActionType(CUSTOMERS_GET_MANY, ActionStatus.START)
    });
    const payload = await getCustomersApiRequest(notArchived, active, isApproved);
    dispatch({
      type: buildActionType(CUSTOMERS_GET_MANY, ActionStatus.DONE),
      payload
    });
  };
};
const getCustomerEvents = (identifier, startTime, endTime, customerId, isDeal, sortLatest) => async dispatch => execute(dispatch, () => getCustomerEventsApiRequest(identifier, startTime, endTime, customerId, isDeal, sortLatest), CUSTOMER_BOOKING_EVENTS_GET_MANY);
const getCustomerEventsForWebDeal = (identifier, startTime, endTime, customerId, isDeal, sortLatest) => async dispatch => execute(dispatch, () => getCustomerEventsForWebDealApiRequest(identifier, startTime, endTime, customerId, isDeal, sortLatest), CUSTOMER_BOOKING_EVENTS_FOR_WEB_DEAL_GET_MANY);
const searchCustomerProducts = keyword => async dispatch => dispatch(executeApiCall(searchCustomerProductsApiRequest(keyword), PRODUCT_VIDEOS_GET_MANY));
export { contactAction, searchCustomerProducts, getCustomerOrder, getCustomerOrders, getCustomerProduct, getCustomerFiles, getProductFiles, markFileSeen, getCourseSections, getCustomerCourse, buyCustomerProduct, getCustomers, getCustomerEvents, getCustomerEventsForWebDeal };